import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

import { MText, H2 } from '@lafabrica/core'

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  @media only screen and (min-width: 769px) {
    margin: 0px 15px;
    height: 80px;
  }
`

const MobileNavText = styled(H2)`
  cursor: pointer;
  color: ${props => props.color};
  margin-bottom: 10px;

  ${props => props.highPriority &&
    `text-decoration: underline;
    color: var(--accent);`
  }
`

const NavText = styled(MText)`
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.color};

  ${props => props.highPriority &&
    `text-decoration: underline;
    color: var(--accent);`
  }

  &:hover {
    color: var(--accent);
  }

  @media only screen and (min-width: 769px) {
    text-transform: uppercase;
  }
`


export const NavLink = ({children, color, onClick, highPriority=false}) => {

  return (
    <Wrapper onClick={onClick}>
      {isMobile ?
        <MobileNavText color={color} highPriority={highPriority}>{children}</MobileNavText>
        :
        <NavText color={color} highPriority={highPriority}>{children}</NavText>
      }
    </Wrapper>
  );
};
